module.exports = __webpack_public_path__ + "img/ameris.88f67de1.png";